import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 业委会信息维护
 */
export class CommitteeInfoControllerSvr {
    constructor() {
        this.baseurl = 'CommitteeInfoControllerSvr.assx/';
    }

    /**
     * 通过物业区域编码获取业委会信息
     * token:String, eaAreaCode:String
     */
    GetOwnerCommitteeByCode(token, eaAreaCode){
        return request.post(this.baseurl + 'GetOwnerCommitteeByCode', Qs.stringify({ token:token, eaAreaCode:eaAreaCode }));
    }

    /**
     * 获取业委会信息
     * token:String, keyID:String
     */
    GetOwnerCommittee(token, keyID){
        return request.post(this.baseurl + 'GetOwnerCommittee', Qs.stringify({ token:token, keyID:keyID }));
    }

    /**
     * 添加业委会信息
     * token:String, OwnerCommittee:OwnerCommittee
     */
    AddOwnerCommittee(token, OwnerCommittee){
        return request.post(this.baseurl + 'AddOwnerCommittee', Qs.stringify({ token:token, OwnerCommittee:(typeof OwnerCommittee === 'undefined' || OwnerCommittee === null) ? '' : OwnerCommittee.toString() }));
    }

    /**
     * 删除业委会信息
     * token:String, orgCode:String
     */
    DeleteOwnerCommittee(token, orgCode){
        return request.post(this.baseurl + 'DeleteOwnerCommittee', Qs.stringify({ token:token, orgCode:orgCode }));
    }

    /**
     * 获取业委会信息列表
     * token:String, orgName:String, startIndex:int, maxSize:int
     */
    GetOwnerCommitteeList(token, orgName, startIndex, maxSize){
        return request.post(this.baseurl + 'GetOwnerCommitteeList', Qs.stringify({ token:token, orgName:orgName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 修改业委会信息
     * token:String, OwnerCommittee:OwnerCommittee
     */
    ModifyOwnerCommittee(token, OwnerCommittee){
        return request.post(this.baseurl + 'ModifyOwnerCommittee', Qs.stringify({ token:token, OwnerCommittee:(typeof OwnerCommittee === 'undefined' || OwnerCommittee === null) ? '' : OwnerCommittee.toString() }));
    }
}